import FlexContent from '@/components/flex-content/FlexContent'

export default function SdgWizardIntro({ components = null }) {
  return (
    <div className="mb-l">
      <h2 className="mb-s">SDG Alignment Tool</h2>

      <h3>How it works</h3>

      <div className="grid grid-cols-3 gap-m">
        <IntroItem
          icon="city"
          title="Choose relevant sectors and roles"
          description="Learn the Basics about what the SDGs are and why they matter for financial services."
        />
        <IntroItem
          icon="research"
          title="Get your custom results and actions"
          description="Dive into the Sectors section to explore how the economic activities you are financing are connected to the SDGs, and to explore ways in which you could optimise for positive SDG alignment"
        />
        <IntroItem
          icon="group"
          title="Share with your colleagues and team"
          description="Combine this with a Roles view for ideas of actions you can take whatever your role in Jersey’s financial services community"
        />
      </div>

      <FlexContent components={components} />
    </div>
  )
}

const IntroItem = ({ icon, title, description }) => {
  return (
    <div className="flex">
      <div className="flex flex-col gap-m rounded-md border p-m">
        <div
          className={`aspect-square w-[90px] flex-shrink-0 items-center justify-center rounded-md bg-theme p-s text-fg theme--primary-50 @[300px]/item:w-[70px] @[330px]/item:w-[90px] @[405px]/item:w-[104px]`}>
          <svg className="aspect-square w-full text-primary" aria-hidden="true">
            <use href={`${process.env.NEXT_PUBLIC_SPRITE_ICONS_PATH}#icon-${icon}`}></use>
          </svg>
        </div>

        <div className="flex flex-col gap-xs">
          <div className="h5 mb-0">{title}</div>

          <div>{description}</div>
        </div>
      </div>
    </div>
  )
}
